<template>
  <div>
    <div
      id="helpModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Help
            </h4>
          </div>
          <div class="modal-body">
            <p>
              Here you can see how well you are doing. You can see 15 indicators
              for the town or for the town and surrounding area.
            </p>
            <p>
              You can also view pop-up graphs to see what happened through
              simulated time and compare your progress to a baseline to see if
              you have improved conditions. The baseline is what would happen if
              you make no changes. There is a different baseline for each of the
              four high-level scenarios – the model will automatically choose
              the right one.
            </p>
            <p>
              After you complete a simulation you can save your results and then
              compare new runs against your earlier results.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import "bootstrap";
export default {
  created() {
    this.$root.$data.eventHub.$on("show-help-modal", this.displayModal);
  },
  methods: {
    displayModal: function () {
      $("#helpModal").modal("show");
    },
  },
};
</script>

<style lang="scss">
.modal-body li {
  list-style-type: none;
  margin: 10px 0;
  padding: 0;
}
.modal-body ul {
  margin: 0;
  padding: 0;
}
.modal-body p {
  margin: 20px 0;
}
.kpi-baseline-undo {
  font-size: inherit;
}
</style>
